// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C13.1046 1 14 1.89543 14 3C14 3.73976 13.5971 4.3835 13 4.72949V7H21V14H23V16H21V22H3V16H1V14H3V7H11V4.72949C10.4029 4.3835 10 3.73976 10 3C10 1.89543 10.8954 1 12 1ZM9 16V18H15V16H9ZM8.5 11C7.67157 11 7 11.6716 7 12.5C7 13.3284 7.67157 14 8.5 14C9.32843 14 10 13.3284 10 12.5C10 11.6716 9.32843 11 8.5 11ZM15.5 11C14.6716 11 14 11.6716 14 12.5C14 13.3284 14.6716 14 15.5 14C16.3284 14 17 13.3284 17 12.5C17 11.6716 16.3284 11 15.5 11Z"}}]};

const RobotFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'robot-filled',
    ref,
    icon: element,
  },
));

RobotFilledIcon.displayName = 'RobotFilledIcon';

export default RobotFilledIcon;
